import { put, delay } from 'redux-saga/effects';
import AjaxActions from '../redux/AjaxRedux';
import i18n from '../i18n';

export function* loginAjax(api, { customerId }) {
  try {
    const loginAjaxResponse = yield api.loginAjax(customerId);
    console.log('loginAjaxResponse:', loginAjaxResponse);
    if (loginAjaxResponse.ok && loginAjaxResponse.data && loginAjaxResponse.data.userId) {
      yield put(AjaxActions.loginAjaxRequestSuccess(loginAjaxResponse.data.userId));
    } else {
      api.checkAuth(loginAjaxResponse);
      let error;
      if (typeof loginAjaxResponse.error !== 'undefined') {
        error = loginAjaxResponse.error;
      } else if (loginAjaxResponse.problem !== 'undefined') {
        error = loginAjaxResponse.problem;
      } else {
        error = i18n.t('unexpectedError');
      }
      console.log('loginAjax error1:', error);
      yield put(AjaxActions.loginAjaxRequestFailure(`${error} logging in to Ajax`));
    }
  } catch (error) {
    console.log('loginAjax error2:', error);
    yield put(AjaxActions.loginAjaxRequestFailure(`${error} logging in to Ajax`));
  }
}

export function* getHubs(api, { customerId, userId }) {
  try {
    const getHubsResponse = yield api.getHubs(customerId, userId);
    console.log('getHubsResponse for userId:', userId, getHubsResponse);
    if (getHubsResponse.ok && getHubsResponse.data) {
      yield put(AjaxActions.getHubsRequestSuccess(getHubsResponse.data));
    } else {
      api.checkAuth(getHubsResponse);
      const error =
        typeof getHubsResponse.problem !== 'undefined' ? getHubsResponse.problem : i18n.t('unexpectedError');
      console.log('getHubs error1:', error);
      yield put(AjaxActions.getHubsRequestFailure(`${error} getting hubs`));
    }
  } catch (error) {
    console.log('getHubs error2:', error);
    yield put(AjaxActions.getHubsRequestFailure(`${error} getting hubs`));
  }
}

export function* getHubDetails(api, { customerId, userId, hubId }) {
  try {
    const getHubDetailsResponse = yield api.getHubDetails(customerId, userId, hubId);
    console.log('getHubDetailsResponse for hubId:', hubId, getHubDetailsResponse);
    if (getHubDetailsResponse.ok && getHubDetailsResponse.data) {
      yield put(AjaxActions.getHubDetailsRequestSuccess(getHubDetailsResponse.data));
    } else {
      api.checkAuth(getHubDetailsResponse);
      const error =
        typeof getHubDetailsResponse.problem !== 'undefined'
          ? getHubDetailsResponse.problem
          : i18n.t('unexpectedError');
      console.log('getHubDetails error1:', error);
      yield put(AjaxActions.getHubDetailsRequestFailure(`${error} getting hub details`));
    }
  } catch (error) {
    console.log('getHubDetails error2:', error);
    yield put(AjaxActions.getHubDetailsRequestFailure(`${error} getting hub details`));
  }
}

export function* getGroups(api, { customerId, userId, hubId, hubIndex }) {
  try {
    const getGroupsResponse = yield api.getGroups(customerId, userId, hubId);
    console.log('getGroupsResponse:', getGroupsResponse);

    if (getGroupsResponse.ok && getGroupsResponse.data) {
      console.log('getGroupsResponse.data:', getGroupsResponse.data);
      yield put(AjaxActions.getGroupsRequestSuccess(getGroupsResponse.data, hubId, hubIndex));
    } else {
      api.checkAuth(getGroupsResponse);
      const error =
        typeof getGroupsResponse.problem !== 'undefined' ? getGroupsResponse.problem : i18n.t('unexpectedError');
      console.log('getGroups error1:', error);
      yield put(AjaxActions.getGroupsRequestFailure(`${error} getting groups`));
    }
  } catch (error) {
    console.log('getGroups error2:', error);
    yield put(AjaxActions.getGroupsRequestFailure(`${error} getting groups`));
  }
}

export function* armHub(api, { customerId, userId, hubId, command, logsPageNumber }) {
  try {
    const armHubResponse = yield api.armHub(customerId, userId, hubId, command);
    yield delay(2000);
    const getHubDetailsResponse = yield api.getHubDetails(customerId, userId, hubId);
    console.log('armHubResponse:', armHubResponse);
    let p = logsPageNumber ? logsPageNumber : 1;
    const getLogsResponse = yield api.getLogs(customerId, userId, hubId, p);
    console.log('getLogsResponse:', getLogsResponse);
    if (armHubResponse.ok && getHubDetailsResponse.ok && getLogsResponse.ok) {
      yield put(AjaxActions.armHubRequestSuccess(getHubDetailsResponse.data, getLogsResponse.data, hubId));
    } else {
      api.checkAuth(armHubResponse);
      api.checkAuth(getHubDetailsResponse);
      api.checkAuth(getLogsResponse);
      const error = typeof armHubResponse.problem !== 'undefined' ? armHubResponse.problem : i18n.t('unexpectedError');
      console.log('armHub error1:', error);
      yield put(AjaxActions.armHubRequestFailure(error));
    }
  } catch (error) {
    console.log('armHub error2:', error);
    yield put(AjaxActions.armHubRequestFailure(error));
  }
}

export function* armGroup(api, { customerId, userId, hubId, hubIndex, groupId, command, logsPageNumber }) {
  try {
    const armGroupResponse = yield api.armGroup(customerId, userId, hubId, groupId, command);
    console.log('armGroupResponse:', armGroupResponse);
    yield delay(2000);
    const getGroupsResponse = yield api.getGroups(customerId, userId, hubId);
    console.log('armGroup getGroupsResponse:', getGroupsResponse);
    const getHubDetailsResponse = yield api.getHubDetails(customerId, userId, hubId);
    console.log('getHubDetailsResponse:', getHubDetailsResponse);
    let p = logsPageNumber ? logsPageNumber : 1;
    const getLogsResponse = yield api.getLogs(customerId, userId, hubId, p);
    console.log('armGroup getLogsResponse:', getLogsResponse);
    if (armGroupResponse.ok && getGroupsResponse.ok && getLogsResponse.ok) {
      yield put(
        AjaxActions.armGroupRequestSuccess(
          getGroupsResponse.data,
          getHubDetailsResponse.data,
          getLogsResponse.data,
          hubId,
          hubIndex
        )
      );
    } else {
      api.checkAuth(armGroupResponse);
      api.checkAuth(getGroupsResponse);
      api.checkAuth(getLogsResponse);
      const error =
        typeof armGroupResponse.problem !== 'undefined' ? armGroupResponse.problem : i18n.t('unexpectedError');
      console.log('armGroup error1:', error);
      yield put(AjaxActions.armGroupRequestFailure(error));
    }
  } catch (error) {
    console.log('armGroup error2:', error);
    yield put(AjaxActions.armGroupRequestFailure(error));
  }
}

export function* getDevices(api, { customerId, userId, hubId }) {
  try {
    const getDevicesResponse = yield api.getDevices(customerId, userId, hubId);
    console.log('getDevicesResponse:', getDevicesResponse);
    if (getDevicesResponse.ok && getDevicesResponse.data) {
      yield put(AjaxActions.getDevicesRequestSuccess(getDevicesResponse.data));
    } else {
      api.checkAuth(getDevicesResponse);
      const error =
        typeof getDevicesResponse.problem !== 'undefined' ? getDevicesResponse.problem : i18n.t('unexpectedError');
      console.log('getDevices error1:', error);
      yield put(AjaxActions.getDevicesRequestFailure(`${error} getting devices`));
    }
  } catch (error) {
    console.log('getDevices error2:', error);
    yield put(AjaxActions.getDevicesRequestFailure(`${error} getting devices`));
  }
}

export function* getRooms(api, { customerId, userId, hubId }) {
  try {
    const getRoomsResponse = yield api.getRooms(customerId, userId, hubId);
    console.log('getRoomsResponse:', getRoomsResponse);
    if (getRoomsResponse.ok && getRoomsResponse.data) {
      yield put(AjaxActions.getRoomsRequestSuccess(getRoomsResponse.data));
    } else {
      api.checkAuth(getRoomsResponse);
      const error =
        typeof getRoomsResponse.problem !== 'undefined' ? getRoomsResponse.problem : i18n.t('unexpectedError');
      console.log('getRooms error1:', error);
      yield put(AjaxActions.getRoomsRequestFailure(`${error} getting rooms`));
    }
  } catch (error) {
    console.log('getRooms error2:', error);
    yield put(AjaxActions.getRoomsRequestFailure(`${error} getting rooms`));
  }
}

export function* getLogs(api, { customerId, userId, hubId, pageNumber }) {
  try {
    let p = pageNumber ? pageNumber : 1;
    const getLogsResponse = yield api.getLogs(customerId, userId, hubId, p);
    console.log('getLogsResponse:', getLogsResponse);
    if (getLogsResponse.ok && getLogsResponse.data) {
      yield put(AjaxActions.getLogsRequestSuccess(getLogsResponse.data, hubId));
    } else {
      api.checkAuth(getLogsResponse);
      const error =
        typeof getLogsResponse.problem !== 'undefined' ? getLogsResponse.problem : i18n.t('unexpectedError');
      console.log('getLogs error1:', error);
      yield put(AjaxActions.getLogsRequestFailure(`${error} getting logs`));
    }
  } catch (error) {
    console.log('getLogs error2:', error);
    yield put(AjaxActions.getLogsRequestFailure(`${error} getting logs`));
  }
}

export function* getAjaxAccessLevelLinks(api, { accessLevelId }) {
  try {
    const getAjaxAccessLevelLinksResponse = yield api.getAjaxAccessLevelLinks(accessLevelId);
    console.log('getAjaxAccessLevelLinksResponse:', getAjaxAccessLevelLinksResponse);
    if (getAjaxAccessLevelLinksResponse.ok && getAjaxAccessLevelLinksResponse.data) {
      yield put(AjaxActions.getAjaxAccessLevelLinksRequestSuccess(getAjaxAccessLevelLinksResponse.data));
    } else {
      api.checkAuth(getAjaxAccessLevelLinksResponse);
      const error =
        typeof getAjaxAccessLevelLinksResponse.problem !== 'undefined'
          ? getAjaxAccessLevelLinksResponse.problem
          : i18n.t('unexpectedError');
      console.log('getAjaxAccessLevelLinks error1:', error);
      yield put(AjaxActions.getAjaxAccessLevelLinksRequestFailure(`${error} getting Ajax access level links`));
    }
  } catch (error) {
    console.log('getAjaxAccessLevelLinks error2:', error);
    yield put(AjaxActions.getAjaxAccessLevelLinksRequestFailure(`${error} getting Ajax access level links`));
  }
}

export function* updateAjaxAccessLevelLinks(api, { ajaxAccessLevelLinks, accessLevelId }) {
  console.log('ajaxAccessLevelLinks:', ajaxAccessLevelLinks);
  try {
    const updateAjaxAccessLevelLinksResponse = yield api.updateAjaxAccessLevelLinks(ajaxAccessLevelLinks);
    console.log('updateAjaxAccessLevelLinksResponse:', updateAjaxAccessLevelLinksResponse);
    const getAjaxAccessLevelLinksResponse = yield api.getAjaxAccessLevelLinks(accessLevelId);
    console.log('getAjaxAccessLevelLinksResponse:', getAjaxAccessLevelLinksResponse);
    if (
      updateAjaxAccessLevelLinksResponse.ok &&
      getAjaxAccessLevelLinksResponse.ok &&
      getAjaxAccessLevelLinksResponse.data
    ) {
      console.log('getAjaxAccessLevelLinksResponse.data:', getAjaxAccessLevelLinksResponse.data);
      const successMessage = i18n.t('successMessage.addAjaxAccessLevelLinksSuccess');
      yield put(
        AjaxActions.updateAjaxAccessLevelLinksRequestSuccess(getAjaxAccessLevelLinksResponse.data, successMessage)
      );
    } else {
      console.log('%c else', 'color: red; font-size: 20px');
      api.checkAuth(updateAjaxAccessLevelLinksResponse);
      api.checkAuth(getAjaxAccessLevelLinksResponse);
      const error =
        typeof updateAjaxAccessLevelLinksResponse.problem !== 'undefined'
          ? updateAjaxAccessLevelLinksResponse.problem
          : i18n.t('unexpectedError');
      console.log('updateAjaxAccessLevelLinks error1:', error);
      yield put(AjaxActions.updateAjaxAccessLevelLinksRequestFailure(`${error} updating Ajax access level links`));
    }
  } catch (error) {
    console.log('updateAjaxAccessLevelLinks error2:', error);
    yield put(AjaxActions.updateAjaxAccessLevelLinksRequestFailure(`${error} updating Ajax access level links`));
  }
}

export function* deleteAjaxAccessLevelLink(api, { ajaxAccessLevelLinkId, accessLevelId }) {
  try {
    const deleteAjaxAccessLevelLinkResponse = yield api.deleteAjaxAccessLevelLink(ajaxAccessLevelLinkId);
    console.log('deleteAjaxAccessLevelLinkResponse:', deleteAjaxAccessLevelLinkResponse);
    const getAjaxAccessLevelLinksResponse = yield api.getAjaxAccessLevelLinks(accessLevelId);
    console.log('getAjaxAccessLevelLinksResponse:', getAjaxAccessLevelLinksResponse);
    if (
      deleteAjaxAccessLevelLinkResponse.ok &&
      getAjaxAccessLevelLinksResponse.ok &&
      getAjaxAccessLevelLinksResponse.data
    ) {
      const successMessage = i18n.t('successMessage.deleteAjaxAccessLevelLinkSuccess');
      yield put(
        AjaxActions.deleteAjaxAccessLevelLinkRequestSuccess(getAjaxAccessLevelLinksResponse.data, successMessage)
      );
    } else {
      api.checkAuth(deleteAjaxAccessLevelLinkResponse);
      const error =
        typeof deleteAjaxAccessLevelLinkResponse.problem !== 'undefined'
          ? deleteAjaxAccessLevelLinkResponse.problem
          : i18n.t('unexpectedError');
      console.log('deleteAjaxAccessLevelLink error1:', error);
      yield put(AjaxActions.deleteAjaxAccessLevelLinkRequestFailure(`${error} deleting Ajax access level links`));
    }
  } catch (error) {
    console.log('deleteAjaxAccessLevelLink error2:', error);
    yield put(AjaxActions.deleteAjaxAccessLevelLinkRequestFailure(`${error} deleting Ajax access level links`));
  }
}
